import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper.js"

export default class extends Controller {
  static get targets() {
    return ['container', 'form'];
  }

  loadEdit(event) {
    event.preventDefault();
    const url = event.target.closest('a').dataset.url;
    this.originalContent = this.containerTarget.innerHTML
    fetch(url)
      .then(response => response.text())
      .then(html => {
        // html is the "edit" partial rendered server-side by our own
        // Subdomain::CollectionsController#edit, fetched from a same-origin,
        // server-generated edit_collection_path -- not user input. Read edit.html.haml:
        // a bare simple_form_for, no raw/html_safe/!=.
        this.containerTarget.innerHTML = html;
      })
      .catch(this.logFailedCall);
  }

  cancelEdit(event) {
    event.preventDefault()
    if (!!this.originalContent) {
      // originalContent is a snapshot of containerTarget's own innerHTML taken in loadEdit,
      // before it was replaced with the edit form -- it is DOM that was already rendered on
      // this page, not new content from a response or user input.
      this.containerTarget.innerHTML = this.originalContent
    }
  }

  submitForm(event) {
    event.preventDefault()

    let url = this.formTarget.action;
    fetch(url, Object.assign(RequestHelper.defaultPostOptions(), {"body": new FormData(this.formTarget)})).
      then(response => response.text()).
      then(html => {
        if (html.length === 0) {
          location.reload();
        } else {
          // html is the "edit" partial re-rendered server-side by our own
          // Subdomain::CollectionsController#update on a validation failure (render :edit,
          // layout: false), fetched from a same-origin, server-generated form action --
          // not user input. Read edit.html.haml: a bare simple_form_for, no raw/html_safe/!=.
          this.containerTarget.innerHTML = html
        }
      })
      .catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }
}
